import { useCallback, useState } from "react"
import HistoryManager from "../utils/historyManager"

export function useHistoryManager<T>(initialState?: T) {
    const [historyManager] = useState(() => new HistoryManager<T>(initialState))
    const [canUndo, setCanUndo] = useState(false)
    const [canRedo, setCanRedo] = useState(false)
    const [currentIndex, setCurrentIndex] = useState<number | null>(
        historyManager.getCurrentIndex(),
    )
    const updateActionState = useCallback(() => {
        setCanUndo(historyManager.canUndo())
        setCanRedo(historyManager.canRedo())
        setCurrentIndex(historyManager.getCurrentIndex())
    }, [historyManager])
    const resetState = useCallback(
        (newState: T) => {
            historyManager.resetState(newState)
            updateActionState()
        },
        [historyManager, updateActionState],
    )
    const updateState = useCallback(
        (newState: T) => {
            historyManager.updateState(newState)
            updateActionState()
        },
        [historyManager, updateActionState],
    )
    const undo = useCallback((): T | null => {
        const state = historyManager.undo()
        updateActionState()
        return state
    }, [historyManager, updateActionState])

    const redo = useCallback((): T | null => {
        const state = historyManager.redo()
        updateActionState()
        return state
    }, [historyManager, updateActionState])

    return {
        resetState,
        currentIndex,
        updateState,
        undo,
        redo,
        canUndo,
        canRedo,
    }
}
